import React from "react";
import { useNavigate } from "react-router-dom"; // Hook for navigation

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Show a confirmation alert
    const confirmLogout = window.confirm("Do you want to log out?");
    
    if (confirmLogout) {
      // Clear authentication data (this could be localStorage, cookies, etc.)
      localStorage.removeItem("authToken"); // Example: Remove auth token
      sessionStorage.removeItem("authToken"); // Example: Remove session token if any
      
      // Redirect to login page ("/")
      navigate("/");
    }
  };

  return (
    <button onClick={handleLogout}>
      Logout
    </button>
  );
};

export default Logout;
